import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {CommonModule} from "@angular/common";
import {IDialogComponent} from "../../../../modules/common/dialog/iDialog.component";
import {DialogWithInput} from "../../../../modules/common/dialog/dialogWithInput";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {DialogModule} from "../../../../modules/common/dialog/dialog.module";
import {ExpandedCardModule} from "../../expanded-card/expanded-card.module";
import {FormFieldModule} from "../../../../modules/core/component/form-field/form-field.module";
import {InputTextareaModule} from "../../../../modules/core/component/input-textarea/input-textarea.module";
import {InputTextModule} from "../../../../modules/core/component/input-text/input-text.module";
import {InputTextComponent} from "../../../../modules/core/component/input-text/input-text.component";

export interface FieldInputCommentDialogInput {
  comment: string;
  label: string;
}

@Component({
  selector: 'app-field-input-comment-dialog',
  templateUrl: './field-input-comment-dialog.component.html',
  standalone: true,
  imports: [
    CommonModule,
    DialogModule,
    ExpandedCardModule,
    FormFieldModule,
    InputTextareaModule,
    InputTextModule,
  ]
})
export class FieldInputCommentDialogComponent implements IDialogComponent<FieldInputCommentDialogInput, string>, OnInit, AfterViewInit {
  dialog: DialogWithInput<FieldInputCommentDialogInput, string>;
  formGroup: FormGroup;

  @ViewChild('inputTextComponent') inputTextComponent: InputTextComponent;

  constructor(private formBuilder: FormBuilder) {
    this.formGroup = this.formBuilder.group({
      comment: this.formBuilder.control(undefined)
    });
  }

  ngOnInit(): void {
    this.formGroup.patchValue({
      comment: this.dialog.input.comment
    });
  }

  ngAfterViewInit() {
    this.inputTextComponent?.focus();
  }

  close() {
    this.dialog.close(this.formGroup.value.comment);
  }

  keyPressed(key) {
    if (key === 'Enter') {
      this.close();
    }
  }


}
